import type { JSX } from 'react'
import React, { PureComponent, Children } from 'react'
import SidePanelMenuItem from './SidePanelMenuItem'
import MenuStyles from './SidePanelMenu.module.scss'
import { IconType } from '../Icon'
import { SidePanelMenuProps } from './types'

class SidePanelMenu extends PureComponent<SidePanelMenuProps> {

  static Item = SidePanelMenuItem

  // Return only valid React Nodes
  getValidChildren = (children) => {

    const validReactChildren: JSX.Element[] = []

    Children.forEach(children, (child, i) => {

      if (!React.isValidElement(child)) return

      validReactChildren.push(child)

    })

    return validReactChildren

  }

  render () {

    const {
      dataBdd = 'sidepanel-menu',
      isOpen = false,
      onMenuOpen = () => {},
      slideControl = true
    } = this.props

    if (typeof this.props.children === 'undefined') return null

    const children = this.getValidChildren(this.props.children)

    return <ul
      data-bdd={dataBdd}
      className={`${MenuStyles['sidemenu']}`}
    >
      {
        slideControl &&
        <SidePanelMenu.Item
          key={'menu-item-status'}
          icon={isOpen ? IconType.iconName.angleRight : IconType.iconName.angleLeft}
          className={isOpen ? MenuStyles['rotate-180'] : ''}
          title={`${isOpen ? 'Close' : 'Open'} the menu`}
          onClick={onMenuOpen}
          panel='slide-control'
          tooltipPosition={this.props.tooltipPosition}
          tooltipText={isOpen ? 'Collapse' : 'Expand'}
        />
      }
      {
        children
      }
    </ul>

  }

}

export default SidePanelMenu
